import { API_ENDPOINTS } from './config/api'

export const getProducts = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.PRODUCTS);
    const data = await response.json();
    
    if (data.status === 'ok') {
      return data.products;
    } else {
      console.error('Erro ao obter produtos:', data.error);
      return [];
    }
  } catch (error) {
    console.error('Erro ao fazer requisição de produtos:', error);
    return [];
  }
};

export default getProducts;
